const DEEPSEARCH_MAP_ANIMATION_PATH = '/animations/deepsearch_map.riv';
const DEEPSEARCH_MAP_PRELOAD_ID = 'deepsearch-map-rive-preload';

export function preloadDeepsearchMapAnimation(): void {
  if (typeof document === 'undefined') {
    return;
  }

  if (document.getElementById(DEEPSEARCH_MAP_PRELOAD_ID) !== null) {
    return;
  }

  const link = document.createElement('link');
  link.id = DEEPSEARCH_MAP_PRELOAD_ID;
  link.rel = 'preload';
  link.as = 'fetch';
  link.href = DEEPSEARCH_MAP_ANIMATION_PATH;
  link.type = 'application/octet-stream';
  link.crossOrigin = 'anonymous';

  document.head.appendChild(link);
}
